import { matchPath } from "react-router-dom";

import {
  IN_HOME_CASE_DETAILS_PATH,
  IN_HOME_CASE_DETAILS_VISIT_OCCURRENCES_PATH,
} from "../InHome/paths";
import { type InHomeCaseHistoryModalRoutePathParams } from "./types";

export function getCaseHistoryModalRouteParams<
  Params extends InHomeCaseHistoryModalRoutePathParams
>(baseNavigationPath: string, locationPathname: string) {
  const match = matchPath<Params>(locationPathname, {
    path: [
      `${baseNavigationPath}/${IN_HOME_CASE_DETAILS_PATH}`,
      `${baseNavigationPath}/${IN_HOME_CASE_DETAILS_VISIT_OCCURRENCES_PATH}`,
    ],
    exact: true,
    strict: false,
  });

  return match?.params;
}
